<template>
  <div class="apiList">
    <slot name="api-list-controls" :filter-options="filterOptions" :set-filter="setFilter" :update-search-string="updateSearchString"></slot>

    <pager 
      v-if="queryObject.limit < total_count" 
      :items-length="total_count" 
      :items-per-page="queryObject.limit"
      :active-index="queryObject.offset"
      :page-options-to-show="pageOptionsToShow"
      @page-to="pageTo"
      className="pager_borderBottom"
      >
    </pager>

    <transition name="v-fade" mode="out-in">
      <slot name="api-list-results" v-if="!fetching" :items="items" :block-columns-class="blockColumnsClass" :fake-data="fakeData"></slot><!-- TODO: Remove fakeDate once real endpoint is used -->
      <div v-else class="spinner"></div>
    </transition>

    <pager 
      v-if="queryObject.limit < total_count" 
      :items-length="total_count" 
      :items-per-page="queryObject.limit"
      :active-index="queryObject.offset"
      :page-options-to-show="pageOptionsToShow"
      @page-to="pageTo"
      className="pager_borderTop"
      >
    </pager>

  </div>
</template>

<script>
import Pager from "./Pager.vue";
// import ListDisplay from './ListDisplay.vue';
import { jsonToQueryString } from "../../utilities/jsonToQueryString.js";
import { camelize } from "../../utilities/camelize.js";
import { debounce } from "../../utilities/debounce.js";

export default {
  components: {
    Pager
  },
  props: {
    initialFilters: Object,
    endpoint: String,
    blockColumns: {
      type: Number,
      default: 1
    },
    pageOptionsToShow: {
      type: Number,
      default: 9
    },
    fakeData: Object,/* TODO: Remove once real endpint is used */
  },
  data() {
    return {
      filterOptions: null,
      items: [],
      queryObject: {
        api_key: "Z5klMMIHxiHVXXa9LSkm5s7Fz0xPJ3n1",
        q: "cats",
        limit: 24,
        offset: 0
      },
      total_count: 0,
      fetching: false
    };
  },
  computed: {
    blockColumnsClass() {
      // MD block columns will be half of LG rounded up.
      if (this.blockColumns === 2) {
        return `flexBlocks flexBlocks_2upMD flexBlocks_2upLG`;
      }
      return `flexBlocks flexBlocks_${Math.ceil(
        this.blockColumns / 2
      )}upMD flexBlocks_${this.blockColumns}upLG`;
    }
  },
  created() {
    //store initial filters
    this.filterOptions = this.initialFilters;

    //dynamically create query object
    for (const item in this.filterOptions) {
      // needs to use $set method to hook up reactivity
      this.$set(this.queryObject, item, null);
    }

    //perform initial fetch
    this.fetchData();
  },
  methods: {
    setFilter(filter, value) {
      console.log(filter, this.queryObject, this.queryObject[filter]);
      this.queryObject[filter] = value;
      this.fetchData();
    },
    updateSearchString: debounce(function(event) {
      if (event.target.value !== "") {
        this.queryObject.q = event.target.value;
        this.fetchData();
      }
    }, 500),
    pageTo(payload) {
      console.log(payload);
      this.queryObject.offset = payload;
      this.fetchData();
    },
    async fetchData() {
      this.fetching = true;

      // get querySring to fetch on
      let queryString = jsonToQueryString(this.queryObject);
      console.log(jsonToQueryString(this.queryObject));

      // fetch for filteroptions and results
      const res = await fetch(this.endpoint + queryString);
      const data = await res.json();

      // update filterOptions

      // update results
      this.items = data.data;
      this.total_count = data.pagination.total_count;

      this.fetching = false;
    }
  }
};
</script>

<style lang="scss">
</style>

